import React from "react";
import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useTranslation } from "react-i18next";

import { materialsStyles } from "../../styles/materials/materialsTableStyles";
import {
  CM_ORDER_DATE,
  CM_PRODUCT_CLIENT_NAME,
  CM_PRODUCT_SWD,
} from "../../utils/consts/materialsConsts";

const SortableHeadCell = ({ column, label, sortBy, sortDirection, onSort }) => (
  <TableCell sx={materialsStyles.tableHeadCell}>
    <TableSortLabel
      sx={materialsStyles.sortLabel}
      active={sortBy === column}
      direction={sortBy === column ? sortDirection : "asc"}
      onClick={() => onSort(column)}
    >
      {label}
    </TableSortLabel>
  </TableCell>
);

export const MaterialsTableHead = ({ sortBy, sortDirection, onSort }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow sx={materialsStyles.tableHeadRow}>
        <TableCell sx={materialsStyles.tableHeadCell}>{t("lp")}</TableCell>

        <SortableHeadCell
          column={CM_PRODUCT_CLIENT_NAME}
          label={t("article")}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSort={onSort}
        />

        <SortableHeadCell
          column={CM_PRODUCT_SWD}
          label={t("protecArticle")}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSort={onSort}
        />

        <TableCell sx={materialsStyles.tableHeadCell}>
          {t("articleDescription")}
        </TableCell>

        <TableCell sx={materialsStyles.tableHeadCell}>{t("quantity")}</TableCell>

        <SortableHeadCell
          column={CM_ORDER_DATE}
          label={t("orderDate")}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSort={onSort}
        />

        <TableCell sx={materialsStyles.tableHeadCell}>
          {t("deliveryDate")}
        </TableCell>
        <TableCell sx={materialsStyles.tableHeadCell}>{t("period")}</TableCell>
        <TableCell sx={materialsStyles.tableHeadCell}>
          {t("earliestDeliveryDate")}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
